import { render } from "./Media.vue?vue&type=template&id=1d1f5ee6"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=1d1f5ee6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/fields/Media.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d1f5ee6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d1f5ee6', __exports__)) {
    api.reload('1d1f5ee6', __exports__)
  }
  
  module.hot.accept("./Media.vue?vue&type=template&id=1d1f5ee6", () => {
    api.rerender('1d1f5ee6', render)
  })

}


export default __exports__